import { createAction, createReducer, createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../store";
import type { Locale } from "@project/common";
import { getInitialLocale } from "@project/common";

export interface LocaleState {
  current: Locale;
}

const initialState: LocaleState = {
  current: getInitialLocale(),
};

export const setDefaultLocale = createAction<Locale>("locale/setDefaultLocale");

export const localeReducer = createReducer(initialState, (builder) => {
  builder.addCase(setDefaultLocale, (state, action) => {
    state.current = action.payload;
  });
});

export const getLocaleSelector = createSelector(
  (state: RootState) => state,
  state => state.locale.current,
);
